export default __webpack_public_path__ + "static/media/contactBanner.0d5c7427.jpg";